import React, { useState } from 'react';

import Button, { ButtonGroup, LoadingButton } from '@atlaskit/button';
import SectionMessage from '@atlaskit/section-message';
import { convertRuleV3ToRuleReference } from 'src/services/rules';

import jira from 'src/lib/api/jira';
import pagerduty from 'src/lib/api/pagerduty';
import { getQueryParams } from 'src/lib/history';
import { usePromise } from 'src/lib/hooks';

import CenteredSpinner from 'src/views/components/CenteredSpinner';
import ErrorMessage from 'src/views/components/ErrorMessage';
import ModalContainer from 'src/views/components/ModalContainer';

const Em = ({ children }) => <span style={{ fontWeight: 'bold' }}>{children}</span>;

const RemoveRuleV3Modal = () => {
  const { loading, data: webhook, error } = usePromise(async () => {
    const { id } = getQueryParams();
    return pagerduty.getWebhook(id, { include: ['webhook_objects'], });
  }, []);

  const rule = convertRuleV3ToRuleReference(webhook);
  const [{ removing, removingError }, setRemoving] = useState({});

  const remove = () => {
    setRemoving({ removing: true });
    pagerduty.deleteWebhook(webhook.id)
      .then(() => jira.closeCurrentModal())
      .catch(removingError => setRemoving({ removingError }));
  };

  return (
    <ModalContainer title="Confirm Rule removal (legacy integration)">
      {loading && <CenteredSpinner size="large"/>}
      {error && <ErrorMessage error={['Failed to load webhook', error]}/>}
      {webhook && <SectionMessage appearance="warning">
        Please confirm Rule removal. <Em>{rule.name}</Em><br/>
        This rule connects:<br/>
        Project: <Em>{rule.config.projects[0].label}</Em><br/>
        Service: <Em>{rule.config.services[0].label}</Em><br/>
        <br/>

      </SectionMessage>}

      {removingError && <ErrorMessage error={['Failed to remove rule', removingError]}/>}
      <br/>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <ButtonGroup>
          <Button onClick={e => jira.closeCurrentModal()}>Cancel</Button>
          <LoadingButton appearance="danger" onClick={remove} isLoading={removing}>Remove Rule</LoadingButton>
        </ButtonGroup>
      </div>

    </ModalContainer>
  );
};

export default RemoveRuleV3Modal;
